import { bufferParamsAPI } from "./api";

export const getBufferParamsList = async (params = {}) => {
  try {
    const res = await bufferParamsAPI.getList(params);
    return res?.data?.map((item, i) => ({ ...item, index: i + 1 }));
  } catch (e) {}
};
export const deleteBufferParam = async (
  floor_buffer_id,
  allIds = null,
  params = {}
) => {
  if (!floor_buffer_id && !allIds) return;
  let body = { floor_buffer_ids: [floor_buffer_id] };
  if (allIds?.length) body = { floor_buffer_ids: [...allIds] };
  try {
    const res = await bufferParamsAPI.deleteParam(body, params);
    return res?.data;
  } catch (e) {}
};

export const bufferParamColumns = [
  {
    name: "index",
    field: "index",
    label: "#",
    align: "center",
  },
  {
    name: "floor_param_type_name",
    field: "floor_param_type_name",
    label: "Тип",
    align: "left",
  },
  {
    name: "floor_buffer_id",
    field: "floor_buffer_id",
    label: "floor_buffer_id",
    align: "center",
  },
  {
    name: "floor_param_id",
    field: "floor_param_id",
    label: "floor_param_id",
    align: "center",
  },
  {
    name: "param_geom",
    field: "param_geom",
    label: "Геом",
    align: "left",
  },
  {
    name: "rowversion",
    field: "rowversion",
    label: "Дата создания",
    align: "center",
  },
  {
    name: "code",
    field: "code",
    label: "Код",
    align: "left",
  },
  {
    name: "delete",
    label: "",
    align: "center",
  },
];

export const bufferFilterOptions = [
  { label: "Все", value: null },
  { label: "Да", value: 1 },
  { label: "Нет", value: 0 },
];
